module.exports = __webpack_public_path__ + "img/diamond-1.bcdd915b.svg";